<template>
  <img :alt="alt" :class="styleClass" :src="url" :onerror="`this.src='${this.urlError}'`">
</template>
<script>
import http from 'axios'

export default {
  props: {
    alt: {
      type: String,
      default: ''
    },
    styleClass: {
      type: String,
      default: 'rounded-circle img-fluid"'
    },
    nomeRede: {
      type: String,
      required: true
    }
  },
  computed: {
    url () {
      return `${http.defaults.baseURL}/redeImagemLogo?q=${this.nomeRede}&t=${new Date().getTime()}`
    },
    urlError () {
      return require('@/img/icon-drachei.svg')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/ImagemRede.vue